import styles from "components/rangebar/CouponDiscountGaugeBar.module.scss";
import {couponMoldTypeToText} from "common/apiConverter";
import {leftTimestampToText} from "common/timeConverter";
import {useContext, useEffect, useState} from "react";
import {numberWithComma} from "common/utils";

import dynamic from 'next/dynamic'
import {LinearProgress} from "@material-ui/core";
import UserContext from "context/AuthContext";
import classNames from "classnames";

const Odometer = dynamic(import('react-odometerjs'), {
    ssr: false,
    loading: () => 0
});


const CouponDiscountGaugeBar = (props) => {
    const {nextAvailableCoupon, bestAvailableCoupon, isPriceLoading, locale} = props;
    const [isInitialized, setIsInitialized] = useState(false);
    const [odometerValue, setOdometerValue] = useState(1234);
    const user = useContext(UserContext).user;


    useEffect(() => {
        if (nextAvailableCoupon) {
            setOdometerValue(nextAvailableCoupon.min_amount - nextAvailableCoupon.total_price);
        }
    }, []);

    useEffect(() => {
        if (nextAvailableCoupon) {
            setOdometerValue(nextAvailableCoupon.min_amount - nextAvailableCoupon.total_price);
        }
    }, [nextAvailableCoupon]);

    useEffect(() => {
        setIsInitialized(true);
    }, [isPriceLoading]);

    const progress = nextAvailableCoupon ? (nextAvailableCoupon.total_price / nextAvailableCoupon.min_amount) * 100 : 100;

    const expiringCoupon = nextAvailableCoupon || bestAvailableCoupon;
    const isCouponDueShown = expiringCoupon ? expiringCoupon.expires_at * 1000 - Date.now() < 1000 * 60 * 60 * 24 * 31 : false;

    return (
        <>
            {
                isInitialized && locale === 'ko' &&
                <>
                    <span className={styles.discountEmphasis}>
                        {
                            user
                                ?
                                (
                                    nextAvailableCoupon
                                        ?
                                        <>
                                            <Odometer value={odometerValue}/><span>원 더 담으면&nbsp;</span>
                                            <span
                                                className={styles.discountDetailEmphasis}> {numberWithComma(nextAvailableCoupon.amount)}{couponMoldTypeToText(nextAvailableCoupon.type)} 할인</span>
                                        </>
                                        :
                                        bestAvailableCoupon
                                            ?
                                            <span
                                                className={styles.discountDetailEmphasis}> {numberWithComma(bestAvailableCoupon.amount)}{couponMoldTypeToText(bestAvailableCoupon.type)} 쿠폰 사용 가능</span>
                                            : <></>
                                )
                                :
                                <span>
                                    로그인하고 쿠폰 할인 받으세요!
                                </span>
                        }
                    </span>
                    {
                        user
                            ?
                            <>
                                <span className={styles.discountDetail}>
                                    {
                                        isCouponDueShown
                                            ? `쿠폰이 ${leftTimestampToText(Date.now(), expiringCoupon.expires_at * 1000)} 뒤에 사라져요`
                                            : '쿠폰이 만료되기 전에 주문하세요!'
                                    }
                                </span>
                                <LinearProgress variant="determinate" value={progress}
                                                className={classNames(styles.progressBar, progress >= 100 && styles.progressBarDone)}
                                />
                            </>
                            :
                            <>
                                {
                                    !user &&
                                    <span className={classNames(styles.discountDetail, styles.discountDetailMargin)}>
                                        <span className={styles.discountDetailEmphasis}>25,000원</span> 상당의 쿠폰팩 증정
                                    </span>
                                }
                            </>
                    }
                </>
            }
        </>
    )
};

export default CouponDiscountGaugeBar;
